(function() {
  var style = document.createElement('style');
  style.textContent = [
    '.shopify-section-template--21201442799875__section_FE8mHY h2, .shopify-section-template--21201442799875__section_FE8mHY p, .shopify-section-template--21201442799875__section_FE8mHY a { color: #1a1a1a !important; }',
    '#shopify-section-sections--21201442930947__footer_m9NzUG .menu__item a { color: #1a1a1a !important; }',
    '.email-signup__button.email-signup__button--text { color: #ffffff !important; }'
  ].join(' ');
  document.head.appendChild(style);
})();

(function() {
  if (localStorage.getItem('cookie_consent')) return;
  var banner = document.createElement('div');
  banner.id = 'sw-cookie-banner';
  banner.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#baa390;color:#1a1a1a;padding:16px 24px;display:flex;align-items:center;justify-content:space-between;gap:16px;z-index:99999;font-family:inherit;font-size:14px;';
  banner.innerHTML = '<span>This site uses cookies to improve your experience. By continuing to browse, you agree to our use of cookies.</span><button onclick="localStorage.setItem(\'cookie_consent\',\'1\');document.getElementById(\'sw-cookie-banner\').remove();" style="background:#1a1a1a;color:#fff;border:none;padding:8px 20px;cursor:pointer;font-size:14px;white-space:nowrap;">Accept</button>';
  document.addEventListener('DOMContentLoaded', function() { document.body.appendChild(banner); });
})();

document.addEventListener('DOMContentLoaded', function() {
  var posterImg = document.querySelector('img.deferred-media__poster-image');
  if (posterImg) posterImg.setAttribute('alt', 'Burringbar Gallery');
  document.querySelectorAll('deferred-media video img').forEach(function(img) {
    if (!img.getAttribute('alt')) img.setAttribute('alt', 'Burringbar Gallery');
  });
});

new MutationObserver(function(mutations, observer) {
  document.querySelectorAll('rte-formatter h4').forEach(function(h4) {
    var h2 = document.createElement('h2');
    h2.innerHTML = h4.innerHTML;
    h2.className = h4.className;
    h4.parentNode.replaceChild(h2, h4);
  });
  if (document.querySelectorAll('rte-formatter h4').length === 0) observer.disconnect();
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', function (e) {
  const link = e.target.closest('a');
  if (!link) return;

  const header = link.closest('header');
  if (!header) return;

  const li = link.closest('li');
  if (!li) return;

  const parentUl = li.parentElement;
  if (!parentUl || parentUl.tagName !== 'UL') return;

  const hasSubmenu = li.querySelector('ul, [role="menu"]');
  if (hasSubmenu && link === li.querySelector('a')) {
    e.preventDefault();
  }
});
